export enum STEP_TYPES {
    REALESTATE = 1,
    CONTACT = 2,
    FINISH = 3,
    SELECT = 4,
    TEXT = 5,
    DAMAGE = 6,
    NAMEPLATES = 7,
    KEYS = 8,
    DOCUMENT_QUESTION = 9,
    CONTACT_PERSONS = 10
}

export interface Process {
    id: string;
    icon: string;
    process_mls: { language: string; title: string; hint?: string }[];
    steps: Step[];
    notificationtype: number;
}

export interface Step {
    id: string;
    type: STEP_TYPES;
    parameters?: {
        rootcomponent?: string;
        required?: boolean;
    };
    step_mls: { language: string; title: string; hint?: string }[];
}
